import { MenuDataItem } from '@ant-design/pro-layout'
import { cmsI18n } from '@cms/i18n'
import { paths } from '@cms/routes'
import { PinedContentType } from '@cms/types'
import { contentTypeCategories, multipleKeys } from '@cms/utils'

import {
  Driver,
  HashtagSquare,
  Image,
  Location,
  Setting2,
  SmsTracking,
  TaskSquare
} from 'iconsax-react'

import { useTranslation } from 'react-i18next'

import { useSelectedMenuItems } from './useSelectedMenuItems'
import { useSidebarComponents } from './useSidebarComponents'

export const useMenuItems = () => {
  const { t } = useTranslation('cms', {
    i18n: cmsI18n,
    bindI18n: 'languageChanged languageChanging'
  })

  const { sidebarComponents } = useSidebarComponents()
  const selected = useSelectedMenuItems()

  const menuItems = [
    {
      icon: <TaskSquare size={20} />,
      key: 'mainTypes',
      name: t('content_type.header'),
      children: [
        {
          key: 'content-types',
          icon: null,
          path: paths.contentTypes.root,
          name: t('content_type.all')
        },
        ...contentTypeCategories.map(({ label, value }) => ({
          key: value,
          icon: null,
          name: label,
          path: `${paths.contentTypes.root}?type=${value}`
        }))
      ]
    },
    {
      icon: <HashtagSquare size={20} />,
      key: 'mainContent',
      name: t('content.header'),
      children:
        (sidebarComponents?.count ?? 0) > 0
          ? [
              {
                key: 'content',
                icon: null,
                name: t('content.all'),
                path: paths.content.root
              },
              ...(sidebarComponents?.results ?? []).map(
                ({ id, name }: PinedContentType) => ({
                  key: id,
                  icon: null,
                  name,
                  path: `${paths.content.root}?type=${id}`
                })
              )
            ]
          : []
    }
  ]

  const additionalMenuItems: MenuDataItem[] = [
    {
      icon: <Driver size={20} />,
      key: 'forms',
      name: t('forms.header'),
      path: paths.forms.root
    },
    {
      icon: <SmsTracking size={20} />,
      key: 'newsletter',
      name: t('newsletter.header'),
      path: paths.newsletter.root
    },
    {
      icon: <Image size={20} />,
      key: multipleKeys(['media', 'media-form'], selected),
      name: t('media.header'),
      path: paths.media.root
    },
    {
      icon: <Location size={20} />,
      key: 'locales',
      name: t('locales.header'),
      path: paths.locales.root
    },
    {
      icon: <Setting2 size={20} />,
      key: 'settings',
      name: t('settings.header'),
      path: paths.settings.root
    }
  ]

  return [...menuItems, ...additionalMenuItems]
}
